import styled from 'styled-components';
import { Field } from 'formik';
import DonationInput from '../form-elements/donation-input';
import { breakpoint } from '../theme/breakpoint';
import { Container } from '../styled/containers';
import { generateBackgroundImages } from '../styled/background-image';
import { h2 } from '../styled/typography';
import {
  OwnAmountSubmit,
  InputBox,
} from '../donation-hero-with-buttons/styles';

export const mobileHeroHeight = 200;
export const tabletHeroHeight = 300;
export const desktopHeroHeight = 650;

const imageSizes = {
  mobile: [null, mobileHeroHeight],
  tablet: [null, tabletHeroHeight],
  desktop: [null, desktopHeroHeight],
};

export const Hero = styled.section`
  position: relative;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing.large};

  ${breakpoint.desktop`
    height: 450px;
  `}
`;

export const ImageWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  ${breakpoint.tablet`
     display: block;
  `};
`;

export const Image = styled.div`
  min-height: ${mobileHeroHeight}px;
  max-height: ${mobileHeroHeight}px;
  height: 100%;
  background-position: center;
  background-size: cover;
  ${({ $image: image }) =>
    image && generateBackgroundImages({ image, imageSizes, size: 'mobile' })};
  order: 2;

  ${breakpoint.tablet`
    min-height: ${tabletHeroHeight}px;
    max-height: ${tabletHeroHeight}px;
    ${({ $image: image }) =>
      image && generateBackgroundImages({ image, imageSizes, size: 'tablet' })};
  `};

  ${breakpoint.desktop`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-height: none;
    ${({ $image: image }) =>
      image &&
      generateBackgroundImages({ image, imageSizes, size: 'desktop' })};
  `}
`;

export const Title = styled.h1`
  ${h2};
  margin-bottom: ${({ theme }) => theme.spacing.large};
  margin-top: 0;
`;

export const Description = styled.p`
  ${breakpoint.desktop`
    min-height: 3em;
  `}
`;

export const StyledContainer = styled(Container)`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0;

  ${breakpoint.desktop`
    padding: 0 ${({ $padding, theme }) =>
      $padding === false ? 0 : theme.spacing.standard};
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex: 1;
`;

export const StyledField = styled(Field)`
  flex-grow: 1;
`;

export const StyledDonationInput = styled(DonationInput)``;

export const StyledOwnAmountSubmit = styled(OwnAmountSubmit)``;

export const StyledInputBox = styled(InputBox)`
  padding: ${({ theme }) => theme.spacing.standard};
`;
